<template>
    <div class="com-smtp">
        <div class="content">
            <ul>
                <span>Gmail开启SMTP服务</span>
                <li>1、点击网址 <a target="_blank" href="https://mail.google.com/mail/?pc=carousel-about-en#settings/fwdandpop">https://mail.google.com/mail/?pc=carousel-about-en#settings/fwdandpop</a></li>
                <li>2、开启请见如下截图</li>
                <img src="@/assets/gmail.png" alt="Gmail开启SMTP服务" /><br /><br />
                <li>3、开启安全性权限，打开网站 <a href="https://myaccount.google.com/lesssecureapps" target="_blank">https://myaccount.google.com/lesssecureapps</a></li>
                <li>4、开启请见如下截图</li>
                <img src="@/assets/gmail2.png" alt="开启安全性权限" />
            </ul>
            <ul>
                <span>Outlook开启SMTP服务</span>
                <li>1、点击网址 <a target="_blank" href="https://outlook.live.com/mail/options/mail/accounts">https://outlook.live.com/mail/options/mail/accounts</a></li>
                <li>2、开启请见如下截图</li>
                <img src="@/assets/outlook.png" alt="Outlook开启SMTP服务" />
            </ul>
        </div>
    </div>

</template>

<script>
export default {
    name: 'site-smtp'
}
</script>

<style lang="less" scoped>
    .com-smtp{background: #eee;text-align: center;font-size: .3rem;}
    .content{display: inline-block; clear: both;text-align: left;margin: auto;width: 100%;max-width: 20rem;margin-bottom: 10px;}
    .content:after{display: block; clear: both;content: '';}	
    .content ul{background: #fff;padding: 30px;margin-bottom: 15px;}
    .content span{font-size: 0.6rem;font-weight: bold;display: block;margin-bottom: 20px;}
    .content img{width: 100%; border: 1px solid #999;}
    .content a{color: #007AFF;}
    .content li{margin-bottom: 7px;}
</style>


